import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  // Extracts pathname property from the current location
  const { pathname } = useLocation();

  useEffect(() => {
    // Automatically scrolls to top-left corner of the window
    window.scrollTo(0, 0);
  }, [pathname]); // This effect runs every time the pathname changes

  return null;
};

export default ScrollToTop;
